// Login page - Runna dark theme
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import RunnaMark from '@/components/RunnaMark'

export default function Login() {
  const { user, loading, signInWithGoogle } = useAuth()

  if (loading) return null
  if (user) return <Navigate to="/" replace />

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(180deg, var(--color-bg) 0%, var(--color-bg2) 100%)' }}>
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="w-16 h-16 mx-auto mb-6 rounded-2xl overflow-hidden shadow-lg shadow-black/30">
            <RunnaMark className="w-full h-full" />
          </div>
          <h1 className="text-3xl font-extrabold text-bright tracking-tight font-heading">Runna</h1>
          <p className="text-muted mt-1 text-xs font-medium uppercase tracking-widest">Influencer Campaign Operations</p>
        </div>

        {/* Card */}
        <div className="bg-card border border-card-border rounded-2xl shadow-2xl p-8">
          <h2 className="text-xl font-bold text-bright text-center mb-2 font-heading">Bem-vindo!</h2>
          <p className="text-dim text-sm text-center mb-8">Faça login para acessar suas campanhas</p>

          <button
            onClick={signInWithGoogle}
            className="w-full flex items-center justify-center gap-3 bg-bg border-2 border-card-border rounded-xl px-6 py-3.5 text-sm font-semibold text-bright hover:border-primary hover:shadow-lg hover:shadow-primary/10 transition-all duration-200 cursor-pointer"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Entrar com Google
          </button>

          <div className="mt-6 text-center">
            <p className="text-dim text-xs">Acesso exclusivo para a equipe de campanhas</p>
          </div>
        </div>

        <p className="text-muted text-xs text-center mt-8">
          Runna &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  )
}
